'use strict';

var _ = require('lodash');
var AdvancedHepSearchService = function AdvancedHepSearchService() {
  function createAdditionalHepSearchRule(searchCriteriaRules) {
    var isFPMarketConfig = _.find(searchCriteriaRules, {
      field: 'type',
      leftOperand: 'FP_MarketConfig'
    }) !== undefined;
    if (isFPMarketConfig) {
      return 'type==FP_BenchmarkCarriers';
    }
  }
  return {
    createAdditionalHepSearchRule: createAdditionalHepSearchRule
  };
};
AdvancedHepSearchService.$inject = [];
module.exports = AdvancedHepSearchService;